module.exports = __webpack_public_path__ + "static/media/senal-colombia.4f409235.svg";